import(/* webpackMode: "eager" */ "/var/www/lumi/apps/student/src/app/error.tsx");
